<script lang="ts">

  const lastUpdated = '2026년 8월 24일'
  const serviceName = 'AX Hub'
  const contactEmail = 'support@1pass.dev'
  // 유예 기간은 서버의 `User.hard_delete_after`(app/models/user.rb) 가 정본이다.
  // 값을 바꾸면 이 문서도 함께 고친다.
  const graceperiod = '6개월'
</script>

  <div class="max-w-3xl mx-auto keep-all">
    <!-- Header -->
    <div class="mb-8">
      <div class="flex items-center gap-2 text-caption text-content-tertiary mb-4">
        <a href="/" class="hover:text-primary transition-colors">홈</a>
        <span>/</span>
        <span class="text-content">계정 삭제</span>
      </div>
      <h1 class="text-h1 text-content mb-2">계정 삭제 안내</h1>
      <p class="text-body2 text-content-tertiary">최종 수정일: {lastUpdated}</p>
    </div>

    <div class="card card-bordered p-8 shadow-md space-y-8">

      <!-- 개요 -->
      <div class="p-4 bg-primary-50 dark:bg-primary/10 border border-primary/20 rounded-xl">
        <p class="text-body2 text-gray-700 dark:text-dark-text-medium leading-relaxed">
          {serviceName} 계정은 앱 안에서 직접 삭제할 수 있습니다.
          앱을 쓸 수 없는 상황이면 {contactEmail} 로 요청해 주세요.
          삭제하면 계정과 작성한 게시글·댓글이 즉시 숨김 처리되고,
          {graceperiod} 뒤 영구 파기됩니다.
        </p>
      </div>

      <!-- 앱에서 직접 삭제 -->
      <section>
        <h2 class="text-title text-content mb-4 pb-2 border-b border-default">
          제1조 (앱에서 직접 삭제)
        </h2>
        <div class="space-y-3 text-body2 text-gray-700 dark:text-dark-text-medium leading-relaxed">
          <p>앱에서 아래 순서로 이동하면 본인이 직접 삭제할 수 있습니다.</p>
          <ol class="list-decimal list-inside space-y-1 pl-1">
            <li>{serviceName} 앱 실행 후 로그인</li>
            <li>하단 <strong>내 정보</strong> 탭</li>
            <li><strong>설정</strong></li>
            <li><strong>계정 삭제</strong></li>
            <li>안내를 읽고 확인 문구를 입력해 삭제 확정</li>
          </ol>
          <p>
            iOS·Android 앱의 경로는 같습니다.
            웹에서는 로그인 후 <a href="/settings" class="text-primary hover:text-primary-dark transition-colors">설정</a> 페이지 맨 아래
            계정 삭제 항목에서 같은 절차를 밟습니다.
          </p>
        </div>
      </section>

      <!-- 이메일로 요청 -->
      <section>
        <h2 class="text-title text-content mb-4 pb-2 border-b border-default">
          제2조 (이메일로 요청)
        </h2>
        <div class="space-y-3 text-body2 text-gray-700 dark:text-dark-text-medium leading-relaxed">
          <p>
            앱에 로그인할 수 없거나 앱을 이미 지운 경우
            <a href="mailto:{contactEmail}" class="text-primary hover:text-primary-dark transition-colors">{contactEmail}</a>
            로 요청해 주세요.
          </p>
          <ul class="list-disc list-inside space-y-1 pl-1">
            <li>제목: 계정 삭제 요청</li>
            <li>본문: 가입에 쓴 이메일 주소</li>
          </ul>
          <p>
            본인 확인을 위해 가입 이메일 주소에서 보내 주세요.
            확인이 끝나면 앱에서 직접 삭제한 것과 같은 절차로 처리하고 회신합니다.
          </p>
        </div>
      </section>

      <!-- 삭제되는 데이터와 시점 -->
      <section>
        <h2 class="text-title text-content mb-4 pb-2 border-b border-default">
          제3조 (삭제되는 데이터와 시점)
        </h2>
        <div class="space-y-3 text-body2 text-gray-700 dark:text-dark-text-medium leading-relaxed">
          <p class="text-body2 font-semibold text-content">삭제 즉시</p>
          <ul class="list-disc list-inside space-y-1 pl-1">
            <li>계정 비활성화 — 로그인·프로필 조회가 모두 막힙니다.</li>
            <li>작성한 게시글·댓글 숨김 — 다른 이용자에게 보이지 않습니다.</li>
            <li>로그인 세션 폐기 — 다른 기기에 남아 있던 세션도 함께 끊깁니다.</li>
            <li>API 접근 토큰·갱신 토큰 폐기</li>
            <li>푸시 알림 기기 등록 삭제 — 이후 알림이 오지 않습니다.</li>
          </ul>
          <p class="text-body2 font-semibold text-content pt-2">삭제 {graceperiod} 뒤</p>
          <ul class="list-disc list-inside space-y-1 pl-1">
            <li>계정 정보(이메일·이름·프로필 이미지 포함) 영구 파기</li>
            <li>작성한 게시글·댓글·발표자료 등 연관 데이터 영구 파기</li>
          </ul>
          <p>
            {graceperiod} 유예는 실수로 삭제한 계정을 되살리기 위한 것입니다.
            이 기간에 복구를 원하면 {contactEmail} 로 문의해 주세요.
            유예 기간이 지나면 복구할 수 없습니다.
          </p>
        </div>
      </section>

      <!-- 법령에 따른 보존 -->
      <section>
        <h2 class="text-title text-content mb-4 pb-2 border-b border-default">
          제4조 (법령에 따른 보존)
        </h2>
        <div class="space-y-3 text-body2 text-gray-700 dark:text-dark-text-medium leading-relaxed">
          <p>관계 법령이 보존을 요구하는 기록은 삭제 후에도 해당 기간 동안 보관합니다.</p>
          <ul class="list-disc list-inside space-y-1 pl-1">
            <li>계약 또는 청약철회 관련 기록: 5년 (전자상거래법)</li>
            <li>접속 로그 기록: 3개월 (통신비밀보호법)</li>
          </ul>
          <p>
            보관 중인 기록은 법령이 정한 목적 외로 쓰지 않으며, 기간이 지나면 파기합니다.
            자세한 내용은 <a href="/privacy" class="text-primary hover:text-primary-dark transition-colors">개인정보처리방침</a>에 있습니다.
          </p>
        </div>
      </section>

    </div>

    <!-- 관련 링크 -->
    <div class="mt-6 flex items-center justify-center gap-4 text-body2">
      <a href="/privacy" class="text-primary hover:text-primary-dark transition-colors">개인정보처리방침</a>
      <span class="text-gray-300 dark:text-dark-text-disabled">|</span>
      <a href="/terms" class="text-primary hover:text-primary-dark transition-colors">이용약관</a>
      <span class="text-gray-300 dark:text-dark-text-disabled">|</span>
      <a href="/" class="text-content-tertiary hover:text-primary transition-colors">홈으로</a>
    </div>
  </div>

<style>
  /* 한국어 어절이 줄 끝에서 쪼개지지 않게 한다. */
  .keep-all {
    word-break: keep-all;
    overflow-wrap: break-word;
  }
</style>
